import { withTitle } from '@gik/core/hocs/withTitle';
import React from 'react';
import { ErrorPageSection } from './ErrorPageSection';

export type ErrorPageProps = {
  error?: unknown;
  statusCode?: number;
};

export function ErrorPage({ error, statusCode }: ErrorPageProps) {
  return withTitle('Error', <ErrorPageSection error={error} statusCode={statusCode} />);
}
